<template>
  <b-modal
    id="modal-payment-confirm"
    :title="$t('Confirmar pagamento')"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    hide-footer
    centered
    @hidden="resetModal"
  >
    <FormulateForm
      ref="formPaymentConfirm"
      name="formPaymentConfirm"
      @submit="onConfirm"
    >
      <b-container>
        <b-row>
          <b-col md="12">
            <FormulateInput
              id="modal_payment_confirm-input_nsu"
              v-model="form.nsu"
              name="nsu"
              :type="isPdvAtm ? 'osk-text' : 'number'"
              class="required"
              validation="required|matches:/^[1-9][0-9]*/"
              :placeholder="$t('0000000')"
              :label="$t('Código de Autorização (NSU da Autorizadora)')"
              osk-type="numeric"
            />
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col class="d-flex justify-content-end">
            <e-button
              id="modal_payment_confirm-btn_cancel"
              class="mr-1"
              variant="danger"
              :text="$t('Cancelar')"
              :text-shortcuts="showShortcuts ? ['ESC'] : []"
              @click="hideModal"
            />
            <e-button
              id="modal_payment_confirm-btn_confirm"
              variant="primary"
              type="submit"
              :text="$t('Confirmar')"
              :text-shortcuts="showShortcuts ? ['CTRL', 'ENTER'] : []"
            />
          </b-col>
        </b-row>
      </b-container>
    </FormulateForm>
  </b-modal>
</template>

<script>
import { BModal, BContainer, BRow, BCol } from 'bootstrap-vue'
import EButton from '@/views/components/EButton.vue'
import { formulateHelper, keyboardCode } from '@/mixins'
import { Shortcuts } from 'shortcuts'
import { mapGetters } from 'vuex'

const getInitialForm = () => ({
  nsu: '',
})

export default {
  components: { BModal, BContainer, BRow, BCol, EButton },

  mixins: [formulateHelper, keyboardCode],

  props: {},

  data() {
    return {
      form: getInitialForm(),
      localReceipt: null,
      shortcuts: new Shortcuts(),
    }
  },

  computed: {
    ...mapGetters('pages/pdv/payBoxConfiguration', ['isPdvAtm']),

    showShortcuts() {
      return !this.isPdvAtm
    },
  },

  methods: {
    onConfirm() {
      this.$emit('click-confirm', this.localReceipt, { nsu: this.form.nsu })
      this.hideModal()
    },

    resetModal() {
      this.form = getInitialForm()
      this.localReceipt = null
    },

    hideModal() {
      this.$bvModal.hide('modal-payment-confirm')
      this.shortcuts.reset()
    },
    showModal(receipt) {
      try {
        this.$bvModal.show('modal-payment-confirm')
        this.resetModal()

        this.localReceipt = receipt

        this.addModalShortcuts()

        this.$nextTick(() => {
          this.focusInput('#modal_payment_confirm-input_nsu')
        })
      } catch (error) {
        /* eslint-disable no-console */
        console.error(error)
        if (error.message) {
          this.showWarning({ message: error.message })
        }
      }
    },

    addModalShortcuts() {
      const { esc, ctrl, enter } = this.keyCode

      this.shortcuts.add([
        {
          shortcut: esc,
          handler: () => {
            this.hideModal()
            return true
          },
        },
        {
          shortcut: [ctrl, enter].join('+'), // get 'Enter' and 'NumpadEnter' keys
          handler: () => {
            // this.onConfirm()
            this.$formulate.submit('formPaymentConfirm')
            return true
          },
        },
      ])
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}

.input-size {
  font-size: 1.4rem;
}
</style>
